export const types = {
  SIGNUP_LOGIN_UPDATE: "SIGNUP_LOGIN_UPDATE",
  EMAIL_FLOW_UPDATE: "EMAIL_FLOW_UPDATE",
  IS_MODAL_VISIBLE: "IS_MODAL_VISIBLE",

  GET_REDUCER_DATA: "GET_REDUCER_DATA",

  SEND_REQUEST: "SEND_REQUEST",
  SEND_REQUEST_INIT: "SEND_REQUEST_INIT",

  GET_HRM_INIT: "GET_HRM_INIT",
  GET_HRM_SUCCESS: "GET_HRM_SUCCESS",
  GET_HRM_FAILURE: "GET_HRM_FAILURE",

  CHECK_USERNAME_UNIQUE: "CHECK_USERNAME_UNIQUE",
  CHECK_USERNAME_UNIQUE_SUCCESS: "CHECK_USERNAME_UNIQUE_SUCCESS",
  CHECK_USERNAME_UNIQUE_FAIL: "CHECK_USERNAME_UNIQUE_FAIL",

  GET_COMPANY_GIGS_INIT: "GET_COMPANY_GIGS_INIT",
  GET_COMPANY_GIGS_SUCCESS: "GET_COMPANY_GIGS_SUCCESS",
  GET_COMPANY_GIGS_FAILURE: "GET_COMPANY_GIGS_FAILURE",

  SEND_REQUEST_SUCCESS: "SEND_REQUEST_SUCCESS",
  SEND_REQUEST_FAILURE: "SEND_REQUEST_FAILURE",

  UPDATE_USER_INFO_SUCCESS: "UPDATE_USER_INFO_SUCCESS",
  UPDATE_USER_INFO_INIT: "UPDATE_USER_INFO_INIT",

  UPLOAD_DOCUMENT_INIT: "UPLOAD_DOCUMENT_INIT",
  UPLOAD_DOCUMENT_SUCCESS: "UPLOAD_DOCUMENT_SUCCESS",
  UPLOAD_DOCUMENT_FAILURE: "UPLOAD_DOCUMENT_FAILURE",
  REMOVE_DOCUMENT_INIT: "REMOVE_DOCUMENT_INIT",

  FETCH_PROFILE_SUCCESS: "FETCH_PROFILE_SUCCESS",
  FETCH_PROFILE_INIT: "FETCH_PROFILE_INIT",
  FETCH_PROFILE_REQUEST_SUCCESS: "FETCH_PROFILE_REQUEST_SUCCESS",
  FETCH_PROFILE_REQUEST_FAILURE: "FETCH_PROFILE_REQUEST_FAILURE",

  UPDATE_PROFILE_INIT: "UPDATE_PROFILE_INIT",
  UPDATE_PROFILE_SUCCESS: "UPDATE_PROFILE_SUCCESS",
  UPDATE_PROFILE_FAILURE: "UPDATE_PROFILE_FAILURE",

  PROFILE_RESET: "PROFILE_RESET",

  GET_PROFILE_URL: "GET_PROFILE_URL",

  UPLOAD_PROFILE_PIC_INIT: "UPLOAD_PROFILE_PIC_INIT",
  UPLOAD_PROFILE_PIC_SUCCESS: "UPLOAD_PROFILE_PIC_SUCCESS",
  UPLOAD_PROFILE_PIC_FAILURE: "UPLOAD_PROFILE_PIC_FAILURE",

  GET_MESSAGE_FAVOURITE_REQUESTED: "GET_MESSAGE_FAVOURITE_REQUESTED",
  GET_MESSAGE_FAVOURITE_SUCCESS: "GET_MESSAGE_FAVOURITE_SUCCESS",
  GET_MESSAGE_FAVOURITE_FAILURE: "GET_MESSAGE_FAVOURITE_FAILURE",

  ADD_MESSAGE_TO_FAVOURITE_REQUESTED: "ADD_MESSAGE_TO_FAVOURITE_REQUESTED",
  ADD_MESSAGE_TO_FAVOURITE_SUCCESS: "ADD_MESSAGE_TO_FAVOURITE_SUCCESS",
  ADD_MESSAGE_TO_FAVOURITE_FAILURE: "ADD_MESSAGE_TO_FAVOURITE_FAILURE",

  REMOVE_MESSAGE_TO_FAVOURITE_REQUESTED:
    "REMO,VE_MESSAGE_TO_FAVOURITE_REQUESTED",
  REMOVE_MESSAGE_TO_FAVOURITE_SUCCESS: "REMOVE_MESSAGE_TO_FAVOURITE_SUCCESS",
  REMOVE_MESSAGE_TO_FAVOURITE_FAILURE: "REMOVE_MESSAGE_TO_FAVOURITE_FAILURE",

  FAVOURITE_SUCCESS: "FAVOURITE_SUCCESS",
  REMOVE_FAV_SUCCESS: "REMOVE_FAV_SUCCESS",

  // REMOVE_MESSAGE_FAVOURITE_REQUESTED: "REMOVE_MESSAGE_FAVOURITE_REQUESTED",
  // REMOVE_MESSAGE_FAVOURITE_SUCCESS: "REMOVE_MESSAGE_FAVOURITE_SUCCESS",
  // REMOVE_MESSAGE_FAVOURITE_FAILURE: "REMOVE_MESSAGE_FAVOURITE_FAILURE",

  REMOVE_MESSAGE_FAVOURITE_INTI: "REMOVE_MESSAGE_FAVOURITE_INTI",
  REMOVE_MESSAGE_FAVOURITE_SUCCESS: "REMOVE_MESSAGE_FAVOURITE_SUCCESS",
  REMOVE_MESSAGE_FAVOURITE_FAILURE: "REMOVE_MESSAGE_FAVOURITE_FAILURE",

  MESSAGE_FAVOURITE_RESET: "MESSAGE_FAVOURITE_RESET",

  UPDATE_PROPOSAL_REQUESTED: "UPDATE_PROPOSAL_REQUESTED",
  UPDATE_PROPOSAL_SUCCESS: "UPDATE_PROPOSAL_SUCCESS",
  UPDATE_PROPOSAL_FAILURE: "UPDATE_PROPOSAL_FAILURE",

  LINKEDIN_TOKEN_INIT: "LINKEDIN_TOKEN_INIT",
  LINKEDIN_TOKEN_SUCCESS: "LINKEDIN_TOKEN_SUCCESS",
  LINKEDIN_TOKEN_FAIL: "LINKEDIN_TOKEN_FAIL",

  SEARCH_GIG_SUGGESTION: "SEARCH_GIG_SUGGESTION_REQUESTED",
  SEARCH_GIG_SUGGESTION_SUCCESS: "SEARCH_GIG_SUGGESTION_SUCCESS",
  SEARCH_GIG_SUGGESTION_FAILURE: "SEARCH_GIG_SUGGESTION_FAILURE",

  CHECK_EXISTING_USER_INIT: "CHECK_EXISTING_USER_INIT",
  CHECK_EXISTING_USER_SUCCESS: "CHECK_EXISTING_USER_SUCCESS",
  CHECK_EXISTING_USER_FAILURE: "CHECK_EXISTING_USER_FAILURE",

  FETCH_SKILLS_INIT: "FETCH_SKILLS_INIT",
  FETCH_SKILLS_SUCCESS: "FETCH_SKILLS_SUCCESS",

  CREATE_SKILL_LISTING_INIT: "CREATE_SKILL_LISTING_INIT",
  UPDATE_SKILL_LISTING_INIT: "UPDATE_SKILL_LISTING_INIT",
  UPDATE_SKILL_LISTING_SUCCESS: "UPDATE_SKILL_LISTING_SUCCESS",
  UPDATE_SKILL_LISTING_SAVE: "UPDATE_SKILL_LISTING_SAVE",

  FETCH_USER_SKILLISTING_INIT: "FETCH_USER_SKILLISTING_INIT",
  FETCH_USER_SKILLISTING_SUCCESS: "FETCH_USER_SKILLISTING_SUCCESS",

  STEP_ONE: "STEP_ONE",
  SKILLISTING: "SKILLISTING",
  FETCH_LOCATION_SAVE: "FETCH_LOCATION_SAVE",

  FETCH_SEARCH_LOCATION_INIT: "FETCH_SEARCH_LOCATION_INIT",
  FETCH_SEARCH_LOCATION_SUCCESS: "FETCH_SEARCH_LOCATION_SUCCESS",
  FETCH_SEARCH_LOCATION_FAILURE: "FETCH_SEARCH_LOCATION_FAILURE",
  FETCH_SEARCH_LOCATION_SAVE: "FETCH_SEARCH_LOCATION_SAVE",
  FETCH_SEARCH_LOCATION_PENDING: "FETCH_SEARCH_LOCATION_PENDING",

  FETCH_SEARCH_DYNAMIC_LOCATION_INIT: "FETCH_SEARCH_DYNAMIC_LOCATION_INIT",
  FETCH_SEARCH_DYNAMIC_LOCATION_SUCCESS:
    "FETCH_SEARCH_DYNAMIC_LOCATION_SUCCESS",
  FETCH_SEARCH_DYNAMIC_LOCATION_FAILURE:
    "FETCH_SEARCH_DYNAMIC_LOCATION_FAILURE",

  FETCH_SEARCH_COMPANY_AND_INDUSTRIES_INIT:
    "FETCH_SEARCH_COMPANY_AND_INDUSTRIES_INIT",
  FETCH_SEARCH_COMPANY_AND_INDUSTRIES_SUCCESS:
    "FETCH_SEARCH_COMPANY_AND_INDUSTRIES_SUCCESS",
  FETCH_SEARCH_COMPANY_AND_INDUSTRIES_FAILURE:
    "FETCH_SEARCH_COMPANY_AND_INDUSTRIES_FAILURE",

  FETCH_SEARCH_SKILLS_INIT: "FETCH_SEARCH_SKILLS_INIT",
  FETCH_SEARCH_SKILLS_SUCCESS: "FETCH_SEARCH_SKILLS_SUCCESS",
  FETCH_SEARCH_SKILLS_FAILURE: "FETCH_SEARCH_SKILLS_FAILURE",

  //region
  FETCH_REGION_SUGGESTIONS_INIT: "FETCH_REGION_SUGGESTIONS_INIT",
  FETCH_REGION_SUGGESTIONS_SUCCESS: "FETCH_REGION_SUGGESTIONS_SUCCESS",
  FETCH_REGION_SUGGESTIONS_FAILURE: "FETCH_REGION_SUGGESTIONS_FAILURE",
  //state
  FETCH_STATE_SUGGESTIONS_INIT: "FETCH_STATE_SUGGESTIONS_INIT",
  FETCH_STATE_SUGGESTIONS_SUCCESS: "FETCH_STATE_SUGGESTIONS_SUCCESS",
  FETCH_STATE_SUGGESTIONS_FAILURE: "FETCH_STATE_SUGGESTIONS_FAILURE",

  FETCH_SEARCH_DISCIPLINE_INIT: "FETCH_SEARCH_DISCIPLINE_INIT",
  FETCH_SEARCH_DISCIPLINE_SUCCESS: "FETCH_SEARCH_DISCIPLINE_SUCCESS",
  SEARCH_DISCIPLINE_SAVE: "SEARCH_DISCIPLINE_SAVE",
  SKILLLISTING_FAILURE: "SKILLLISTING_FAILURE",

  FETCH_PROFILE_EXPERIENCE_INIT: "FETCH_PROFILE_EXPERIENCE_INIT",
  FETCH_PROFILE_EXPERIENCE_SUCCESS: "FETCH_PROFILE_EXPERIENCE_SUCCESS",
  FETCH_EXPERIENCE_SAVE: "FETCH_EXPERIENCE_SAVE",

  FETCH_MANAGEBIDS_REQUESTED: "GET_MANAGEBIDS_REQUESTED",
  FETCH_MANAGEBIDS_SUCCESS: "GET_MANAGEBIDS_SUCCESS",
  FETCH_MANAGEBIDS_FAILURE: "GET_MANAGEBIDS_FAILURE",

  CREATE_BID_REQUESTED: "CREATE_BID_REQUESTED",
  CREATE_BID_SUCCESS: "CREATE_BID_SUCCESS",
  CREATE_BID_FAILURE: "CREATE_BID_FAILURE",
  CLEAR_BID_SUCCESS: "CLEAR_BID_SUCCESS",

  CREATE_MULTI_BID_REQUESTED: "POST_MULTI_BID_REQUESTED",
  CREATE_MULTI_BID_SUCCESS: "POST_MULTI_BID_SUCCESS",
  CREATE_MULTI_BID_FAILURE: "POST_MULTI_BID_FAILURE",

  Remove_Bidded_skillListings: "Remove_Bidded_skillListings",

  UPDATE_BID_REQUESTED: "UPDATE_BID_REQUESTED",
  UPDATE_BID_SUCCESS: "UPDATE_BID_SUCCESS",
  UPDATE_BID_FAILURE: "UPDATE_BID_FAILURE",
  CLEAR_UPDATE_BID_SUCCESS: "CLEAR_UPDATE_BID_SUCCESS",

  GET_CONVERSATION_ID_INIT: "GET_CONVERSATION_ID_INIT",
  GET_CONVERSATION_ID_SUCCESS: "GET_CONVERSATION_ID_SUCCESS",
  GET_CONVERSATION_ID_FAILURE: "GET_CONVERSATION_ID_FAILURE",

  GET_CONVERSATION_COUNT_INIT: "GET_CONVERSATION_COUNT_INIT",
  GET_CONVERSATION_COUNT_SUCCESS: "GET_CONVERSATION_COUNT_SUCCESS",
  GET_CONVERSATION_COUNT_FAILURE: "GET_CONVERSATION_COUNT_FAILURE",

  FETCH_MESSAGES_REQUESTED: "FETCH_MESSAGES_REQUESTED",
  FETCH_MESSAGES_SUCCESS: "FETCH_MESSAGES_SUCCESS",
  FETCH_MESSAGES_FAILURE: "FETCH_MESSAGES_FAILURE",

  GET_MESSAGES_COUNTS_INIT: "GET_MESSAGES_COUNTS_INIT",
  GET_MESSAGES_COUNTS_FAILURE: "GET_MESSAGES_COUNTS_FAILURE",
  GET_MESSAGES_COUNTS_SUCCESS: "GET_MESSAGES_COUNTS_SUCCESS",

  RETRACT_BID_REQUESTED: "RETRACT_BID_REQUESTED",
  RETRACT_BID_SUCCESS: "RETRACT_BID_SUCCESS",
  RETRACT_BID_FAILURE: "RETRACT_BID_FAILURE",
  CLEAR_RETRACT_BID: "CLEAR_RETRACT_BID",

  CREATE_INTERVIEW_REQUESTED: "CREATE_INTERVIEW_REQUESTED",
  CREATE_INTERVIEW_SUCCESS: "CREATE_INTERVIEW_SUCESS",
  CREATE_INTERVIEW_FAILURE: "CREATE_INTERVIEW_FAILURE",

  UPDATE_INTERVIEW_REQUESTED: "UPDATE_INTERVIEW_REQUESTED",
  UPDATE_INTERVIEW_SUCCESS: "UPDATE_INTERVIEW_SUCESS",
  UPDATE_INTERVIEW_FAILURE: "UPDATE_INTERVIEW_FAILURE",

  SEND_MESSAGE_REQUESTED: "SEND_MESSAGE_REQUESTED",
  SEND_MESSAGE_SUCCESS: "SEND_MESSAGE_SUCCESS",
  SEND_MESSAGE_FAILURE: "SEND_MESSAGE_FAILURE",

  MESSAGE_RECEIVED: "MESSAGE_RECEIVED",

  MESSAGE_RECEIVED_INIT: "MESSAGE_RECEIVED_INIT",
  MESSAGE_RECEIVED_SUCCESS: "MESSAGE_RECEIVED_SUCCESS",
  MESSAGE_RECEIVED_FAILURE: "MESSAGE_RECEIVED_FAILURE",

  SEND_MESSAGE_ATTACHMENT_REQUESTED: "SEND_MESSAGE_ATTACHMENT_REQUESTED",
  SEND_MESSAGE_ATTACHMENT_SUCCESS: "SEND_MESSAGE_ATTACHMENT_SUCCESS",
  SEND_MESSAGE_ATTACHMENT_FAILURE: "SEND_MESSAGE_ATTACHMENT_FAILURE",

  FETCH_CHAT_REQUESTED: "GET_CHAT_REQUESTED",
  FETCH_CHAT_SUCCESS: "GET_CHAT_SUCCESS",
  FETCH_CHAT_FAILURE: "GET_CHAT_FAILURE",

  RESET_CHAT_REDUCER: "RESET_CHAT_REDUCER",

  READ_NOTIFICATION: "READ_NOTIFICATION",
  READ_NOTIFICATION_SUCCESS: "READ_NOTIFICATION_SUCCESS",
  READ_NOTIFICATION_FAILURE: "READ_NOTIFICATION_FAILURE",

  FETCH_PROFILE_DETAILS_REQUESTED: "FETCH_PROFILE_DETAILS_REQUESTED",
  FETCH_PROFILE_DETAILS_SUCCESS: "FETCH_PROFILE_DETAILS_SUCCESS",
  FETCH_PROFILE_DETAILS_FAILURE: "FETCH_PROFILE_DETAILS_FAILURE",

  FETCH_PROFILE_REVIEWS_REQUESTED: "FETCH_PROFILE_REVIEWS_REQUESTED",
  FETCH_PROFILE_REVIEWS_SUCCESS: "FETCH_PROFILE_REVIEWS_SUCCESS",
  FETCH_PROFILE_REVIEWS_FAILURE: "FETCH_PROFILE_REVIEWS_FAILURE",

  UPDATE_PERSONAL_DETAILS_REQUESTED: "UPDATE_PERSONAL_DETAILS_REQUESTED",
  UPDATE_PERSONAL_DETAILS_SUCCESS: "UPDATE_PERSONAL_DETAILS_SUCCESS",
  UPDATE_PERSONAL_DETAILS_FAILURE: "UPDATE_PERSONAL_DETAILS_FAILURE",

  SEARCH_LISTING_INIT: "SEARCH_LISTING_INIT",
  SEARCH_LISTING_SUCCESS: "SEARCH_LISTING_SUCCESS",
  SEARCH_LISTING_FAILURE: "SEARCH_LISTING_FAILURE",
  SEARCH_VALUE: "SEARCH_VALUE",
  SEARCH_TYPE: "SEARCH_TYPE",

  SEARCH_ICON_CLICKED: "SEARCH_ICON_CLICKED", // when search icon is called
  CLEAR_SEARCH_ICON_CLICKED: "CLEAR_SEARCH_ICON_CLICKED", // CLEAR the state after search icon is called

  SKILL_LISTING_COUNT_INIT: " SKILL_LISTING_COUNT_INIT",
  SKILL_LISTING_COUNT_SUCCESS: " SKILL_LISTING_COUNT_SUCCESS",
  SKILL_LISTING_COUNT_FAILURE: " SKILL_LISTING_COUNT_FAILURE",

  SKILL_LISTING_TOTALCOUNT_INIT: " SKILL_LISTING_TOTALCOUNT_INIT",
  SKILL_LISTING_TOTALCOUNT_SUCCESS: " SKILL_LISTING_TOTALCOUNT_SUCCESS",
  SKILL_LISTING_TOTALCOUNT_FAILURE: " SKILL_LISTING_TOTALCOUNT_FAILURE",

  MY_GIG_FILTERS_REQUESTED: "MY_GIG_FILTERS_REQUESTED",
  MY_GIG_FILTERS_FAILURE: "MY_GIG_FILTERS_FAILURE",
  MY_GIG_FILTERS_SUCCESS: "GET_FILTERS_SUCCESS",

  GET_FILTERS_REQUESTED: "GET_FILTERS_REQUESTED",
  GET_FILTERS_FAILURE: "GET_FILTERS_FAILURE",
  GET_FILTERS_SUCCESS: "GET_FILTERS_SUCCESS",

  FETCH_KEYWORDS_INIT: "FETCH_KEYWORDS_INIT",
  FETCH_KEYWORDS_SUCCESS: "FETCH_KEYWORDS_SUCCESS",
  FETCH_KEYWORDS_FAILURE: "FETCH_KEYWORDS_FAILURE",

  SEARCH_SUGGESTIONS_REQUESTED: "SEARCH_SUGGESTIONS_REQUESTED",
  SEARCH_SUGGESTIONS_SUCCESS: " SEARCH_SUGGESTIONS_SUCCESS",
  SEARCH_SUGGESTIONS_FAILURE: " SEARCH_SUGGESTIONS_FAILURE",

  GET_COMPANY_DETAILS_REQUESTED: "GET_COMPANY_DETAILS_REQUESTED",
  GET_COMPANY_DETAILS_SUCCESS: "GET_COMPANY_DETAILS_SUCCESS",
  GET_COMPANY_DETAILS_FAILURE: "GET_COMPANY_DETAILS_FAILURE",

  GET_COMPANYPROFILEDETAILS_REQUESTED: "GET_COMPANYPROFILEDETAILS_REQUESTED",
  GET_COMPANYPROFILEDETAILS_FAILURE: "GET_COMPANYPROFILEDETAILS_FAILURE",
  GET_COMPANYPROFILEDETAILS_SUCCESS: "GET_COMPANYPROFILEDETAILS_SUCCESS",

  UPDATE_COMPANYPROFILELINKEDACCOUNTS_REQUESTED:
    "UPDATE_COMPANYPROFILELINKEDACCOUNTS_REQUESTED",
  UPDATE_COMPANYPROFILELINKEDACCOUNTS_FAILURE:
    "UPDATE_COMPANYPROFILELINKEDACCOUNTS_FAILURE",
  UPDATE_COMPANYPROFILELINKEDACCOUNTS_SUCCESS:
    "UPDATE_COMPANYPROFILELINKEDACCOUNTS_SUCCESS",

  GET_PERSONALDETAILSLOCATION_REQUESTED:
    "GET_PERSONALDETAILSLOCATION_REQUESTED",
  GET_PERSONALDETAILSLOCATION_FAILURE: "GET_PERSONALDETAILSLOCATION_FAILURE",
  GET_PERSONALDETAILSLOCATION_SUCCESS: "GET_PERSONALDETAILSLOCATION_SUCCESS",

  SYNC_PROFILE_WIZARD_FLOW: "SYNC_PROFILE_WIZARD_FLOW",

  POST_COMPANY_DETAILS_REQUESTED: "POST_COMPANY_DETAILS_REQUESTED",
  POST_COMPANY_DETAILS_RESET: "POST_COMPANY_DETAILS_RESET",
  POST_COMPANY_DETAILS_SUCCESS: "POST_COMPANY_DETAILS_SUCCESS",
  POST_COMPANY_DETAILS_FAILURE: "POST_COMPANY_DETAILS_FAILURE",
  POST_TALENT_DETAILS_RESET: "POST_TALENT_DETAILS_RESET",

  FETCH_GIGSALL_REQUESTED: "FETCH_GIGSALL_REQUESTED",
  FETCH_GIGSALL_SUCCESS: "FETCH_GIGSALL_SUCCESS",
  FETCH_GIGSALL_FAILURE: "FETCH_GIGSALL_FAILURE",

  GET_CULTURE_PHOTOS_REQUESTED: "GET_CULTURE_PHOTOS_REQUESTED",
  GET_CULTURE_PHOTOS_SUCCESS: "GET_CULTURE_PHOTOS_SUCCESS",
  GET_CULTURE_PHOTOS_FAILURE: "GET_CULTURE_PHOTOS_FAILURE",

  GET_VIEWS_REQUESTED: "GET_VIEWS_REQUESTED",
  GET_VIEWS_SUCCESS: "GET_VIEWS_SUCCESS",
  GET_VIEWS_FAILURE: "GET_VIEWS_FAILURE",

  GET_FOLLOWERS_REQUESTED: "GET_FOLLOWERS_REQUESTED",
  GET_FOLLOWERS_SUCCESS: "GET_FOLLOWERS_SUCCESS",
  GET_FOLLOWERS_FAILURE: "GET_FOLLOWERS_FAILURE",

  GET_EMP_ALBUMS_REQUESTED: "GET_EMP_ALBUMS_REQUESTED",
  GET_EMP_ALBUMS_SUCCESS: "GET_EMP_ALBUMS_SUCCESS",
  GET_EMP_ALBUMS_FAILURE: "GET_EMP_ALBUMS_FAILURE",

  GET_SEARCH_SKILLS_REQUESTED: "GET_SEARCH_SKILLS_REQUESTED",
  GET_SEARCH_SKILLS_SUCCESS: "GET_SEARCH_SKILLS_SUCCESS",
  GET_SEARCH_SKILLS_FAILURE: "GET_SEARCH_SKILLS_FAILURE",

  GET_GIG_ROLES_REQUESTED: "GET_GIG_ROLES_REQUESTED",
  GET_GIG_ROLES_SUCCESS: "GET_GIG_ROLES_SUCCESS",
  GET_GIG_ROLES_FAILURE: "GET_GIG_ROLES_FAILURE",

  WIZARD_FINISHED: "WIZARD_FINISHED",
  CLEAR_EDIT_OFFER_RESPONSE: "CLEAR_EDIT_OFFER_RESPONSE",

  UPDATE_EMP_ALBUMS_REQUESTED: "UPDATE_EMP_ALBUMS_REQUESTED",
  UPDATE_EMP_ALBUMS_SUCCESS: "UPDATE_EMP_ALBUMS_SUCCESS",
  UPDATE_EMP_ALBUMS_FAILURE: "UPDATE_EMP_ALBUMS_FAILURE",
  UPDATE_EMP_ALBUMS_RESET: "UPDATE_EMP_ALBUMS_RESET",

  EDIT_EMP_ALBUMS_REQUESTED: "EDIT_EMP_ALBUMS_REQUESTED",
  EDIT_EMP_ALBUMS_SUCCESS: "EDIT_EMP_ALBUMS_SUCCESS",
  EDIT_EMP_ALBUMS_FAILURE: "EDIT_EMP_ALBUMS_FAILURE",
  EDIT_EMP_ALBUMS_RESET: "EDIT_EMP_ALBUMS_RESET",

  DELETE_EMP_ALBUMS_REQUESTED: "DELETE_EMP_ALBUMS_REQUESTED",
  RESET_DELETE_SUCCESS: "RESET_DELETE_SUCCESS",
  DELETE_EMP_ALBUMS_SUCCESS: "DELETE_EMP_ALBUMS_SUCCESS",
  DELETE_EMP_ALBUMS_FAILURE: "DELETE_EMP_ALBUMS_FAILURE",

  GET_GIG_REQUESTED: "GET_GIG_REQUESTED",
  GET_GIG_SUCCESS: "GET_GIG_SUCCESS",
  GET_GIG_FAILURE: "GET_GIG_FAILURE",

  UPDATE_GIG_REQUESTED: "UPDATE_GIG_REQUESTED",
  UPDATE_GIG_SUCCESS: "UPDATE_GIG_SUCCESS",
  UPDATE_GIG_FAILURE: "UPDATE_GIG_FAILURE",

  CREATE_GIG_REQUESTED: "CREATE_GIG_REQUESTED",
  CREATE_GIG_SUCCESS: "CREATE_GIG_SUCESS",
  CREATE_GIG_FAILURE: "CREATE_GIG_FAILURE",
  CREATE_GIG_RESET: "CREATE_GIG_RESET",

  GET_CANDIDATE_SKILLLISTING: "GET_CANDIDATE_SKILLLISTING",
  GET_CANDIDATE_SKILLLISTING_SUCCESS: "GET_CANDIDATE_SKILLLISTING_SUCCESS",
  GET_CANDIDATE_SKILLLISTING_FAILURE: "GET_CANDIDATE_SKILLLISTING_FAILURE",

  GET_JOB_LISTING: "GET_JOB_LISTING",
  GET_JOB_LISTING_SUCCESS: "GET_JOB_LISTING_SUCESS",
  GET_JOB_LISTING_FAILURE: "GET_JOB_LISTING_FAILURE",
  GET_JOB_LISTING_RESET: "GET_JOB_LISTING_RESET",

  GET_JOB_LISTING_DRAFT: "GET_JOB_LISTING_DRAFT",
  GET_JOB_LISTING_DRAFT_SUCCESS: "GET_JOB_LISTING_DRAFT_SUCESS",
  GET_JOB_LISTING_DRAFT_FAILURE: "GET_JOB_LISTING_DRAFT_FAILURE",
  GET_JOB_LISTING_DRAFT_RESET: "GET_JOB_LISTING_DRAFT_RESET",

  GET_JOB_LISTING_RECENT_REQUESTED: "GET_JOB_LISTING_RECENT_REQUESTED",
  GET_JOB_LISTING_RECENT_SUCESS: "GET_JOB_LISTING_RECENT_SUCESS",
  GET_JOB_LISTING_RECENT_FAILURE: "GET_JOB_LISTING_RECENT_FAILURE",

  GET_ONE_USER_SKILLLISTING_REQUESTED: "GET_ONE_USER_SKILLLISTING_REQUESTED",
  GET_ONE_USER_SKILLLISTING_SUCCESS: "GET_ONE_USER_SKILLLISTING_SUCCESS",
  GET_ONE_USER_SKILLLISTING_FAILURE: "GET_ONE_USER_SKILLLISTINFAILUREED",
  CLEAR_ONE_USER_SKILLLISTING_SUCCESS: "CLEAR_ONE_USER_SKILLLISTING_SUCCESS",
  GET_ONE_USER_SKILLLISTING_FAVOUTITE: "GET_ONE_USER_SKILLLISTING_FAVOUTITE",
  RESET_ONE_USER_SKILLLISTING_FAVOUTITE:
    "RESET_ONE_USER_SKILLLISTING_FAVOUTITE",

  GET_JOB_TEMPLATES_REQUESTED: "GET_JOB_TEMPLATES_REQUESTED",
  GET_JOB_TEMPLATES_SUCCESS: "GET_JOB_TEMPLATES_SUCCESS",
  GET_JOB_TEMPLATES_FAILURE: "GET_JOB_TEMPLATES_FAILURE",

  DELETE_JOB_REQUESTED: "DELETE_JOB_REQUESTED",
  DELETE_JOB_SUCCESS: "DELETE_JOB_SUCCESS",
  DELETE_JOB_FAILURE: "DELETE_JOB_FAILURE",
  DELETE_JOB_RESET: "DELETE_JOB_RESET",
  CLEAR_JOB_DELETE_SUCCESS: "CLEAR_JOB_DELETE_SUCCESS",

  GET_JOBDETAIL_REQUESTED: "GET_JOBDETAIL_REQUESTED",
  GET_JOBDETAIL_SUCCESS: "GET_JOBDETAIL_SUCCESS",
  GET_JOBDETAIL_FAILURE: "GET_JOBDETAIL_FAILURE",

  GET_JOB_BID_DETAILS: "GET_JOB_BID_DETAILS",
  GET_JOB_BID_SUCCESS: "GET_JOB_BID_SUCCESS",
  GET_JOB_BID_FAILURE: "GET_JOB_BID_FAILURE",

  UPDATE_JOBS_REQUESTED: "UPDATE_JOBS_REQUESTED",
  UPDATE_JOBS_SUCCESS: "UPDATE_JOBS_SUCCESS",
  UPDATE_JOBS_FAILURE: "UPDATE_JOBS_FAILURE",
  UPDATE_JOBS_RESET: "UPDATE_JOBS_RESET",

  FETCH_SEARCH_SUGGESTIONS_INIT: "FETCH_SEARCH_SUGGESTIONS_INIT",
  FETCH_SEARCH_SUGGESTIONS_SUCCESS: "FETCH_SEARCH_SUGGESTIONS_SUCCESS",
  FETCH_SEARCH_SUGGESTIONS_FAILURE: "FETCH_SEARCH_SUGGESTIONS_FAILURE",
  FETCH_SEARCH_SUGGESTIONS_SAVE: "FETCH_SEARCH_SUGGESTIONS_SAVE",

  GET_DASHBOARD_DETAILS_REQUESTED: "GET_DASHBOARD_DETAILS_REQUESTED",
  GET_DASHBOARD_DETAILS_SUCCESS: "GET_DASHBOARD_DETAILS_SUCCESS",
  GET_DASHBOARD_DETAILS_FAILURE: "GET_DASHBOARD_DETAILS_FAILURE",

  GET_DASHBOARD_INTERVIEWS_REQUESTED: "GET_DASHBOARD_INTERVIEWS_REQUESTED",
  GET_DASHBOARD_INTERVIEWS_SUCCESS: "GET_DASHBOARD_INTERVIEWS_SUCCESS",
  GET_DASHBOARD_INTERVIEWS_FAILURE: "GET_DASHBOARD_INTERVIEWS_FAILURE",

  GET_DASHBOARD_MATCHES_REQUESTED: "GET_DASHBOARD_MATCHES_REQUESTED",
  GET_DASHBOARD_MATCHES_SUCCESS: "GET_DASHBOARD_MATCHES_SUCCESS",
  GET_DASHBOARD_MATCHES_FAILURE: "GET_DASHBOARD_MATCHES_FAILURE",

  GET_RESUME3D_REQUESTED: "GET_RESUME3D_REQUESTED",
  GET_RESUME3D_SUCCESS: "GET_RESUME3D_SUCCESS",
  GET_RESUME3D_FAILURE: "GET_RESUME3D_FAILURE",

  POST_FOLLOW_REQUESTED: "POST_FOLLOW_REQUESTED",
  POST_FOLLOW_SUCCESS: "POST_FOLLOW_SUCCESS",
  POST_FOLLOW_FAILURE: "POST_FOLLOW_FAILURE",

  POST_UNFOLLOW_REQUESTED: "POST_UNFOLLOW_REQUESTED",
  POST_UNFOLLOW_SUCCESS: "POST_UNFOLLOW_SUCCESS",
  POST_UNFOLLOW_FAILURE: "POST_UNFOLLOW_FAILURE",

  GET_SKILL_MACTHES_REQUESTED: "GET_SKILL_MACTHES_REQUESTED",
  GET_SKILL_MACTHES_SUCCESS: "GET_SKILL_MACTHES_SUCCESS",
  GET_SKILL_MACTHES_FAILURE: "GET_SKILL_MACTHES_FAILURE",

  GET_ALLINTERVIEWS_REQUESTED: "GET_ALLINTERVIEWS_REQUESTED",
  GET_ALLINTERVIEWS_SUCCESS: "GET_ALLINTERVIEWS_SUCCESS",
  GET_ALLINTERVIEWS_FAILURE: "GET_ALLINTERVIEWS_FAILURE",

  // POST_MATCHES_REQUESTED: "POST_MATCHES_REQUESTED",
  // POST_MATCHES_SUCCESS: "POST_MATCHES_SUCCESS",
  // POST_MATCHES_FAILURE: "POST_MATCHES_FAILURE",

  ADD_TO_MATCHES_REQUESTED: "ADD_TO_MATCHES_REQUESTED",
  ADD_TO_MATCHES_SUCCESS: "ADD_TO_MATCHES_SUCCESS",
  ADD_TO_MATCHES_FAILURE: "ADD_TO_MATCHES_FAILURE",
  CLEAR_MATCHES_SUCCESS: "CLEAR_MATCHES_SUCCESS",

  ADD_SINGLE_MATCHES_REQUESTED: "ADD_SINGLE_MATCHES_REQUESTED",
  ADD_SINGLE_MATCHES_SUCCESS: "ADD_SINGLE_MATCHES_SUCCESS",
  ADD_SINGLE_MATCHES_FAILURE: "ADD_SINGLE_MATCHES_FAILURE",
  CLEAR_SINGLE_MATCHES_SUCCESS: "CLEAR_SINGLE_MATCHES_SUCCESS",

  ADD_BATCH_MATCHES_REQUESTED: "ADD_BATCH_MATCHES_REQUESTED",
  ADD_BATCH_MATCHES_SUCCESS: "ADD_BATCH_MATCHES_SUCCESS",
  ADD_BATCH_MATCHES_FAILURE: "ADD_BATCH_MATCHES_FAILURE",
  CLEAR_BATCH_MATCHES_SUCCESS: "CLEAR_BATCH_MATCHES_SUCCESS",

  REMOVE_FROM_MATCHES_REQUESTED: "REMOVE_FROM_MATCHES_REQUESTED",
  REMOVE_FROM_MATCHES_SUCCESS: "REMOVE_FROM_MATCHES_SUCCESS",
  REMOVE_FROM_MATCHES_FAILURE: "REMOVE_FROM_MATCHES_FAILURE",

  FIND_MATCH_REQUESTED: "FIND_MATCH_REQUESTED",
  FIND_MATCH_FAILURE: "FIND_MATCH_FAILURE",
  FIND_MATCH_SUCCESS: "FIND_MATCH_SUCCESS",
  MATCHES_RESET: "MATCHES_RESET",

  GET_MATCHES_COUNT: "GET_MATCHES_COUNT",
  GET_MATCHES_COUNT_SUCCESS: "GET_MATCHES_COUNT_SUCCESS",
  GET_MATCHES_COUNT_FAILURE: "GET_MATCHES_COUNT_FAILURE",

  GET_MORE_MATCHES_INIT: "GET_MORE_MATCHES_INIT",
  GET_MORE_MATCHES_SUCCESS: "GET_MORE_MATCHES_SUCCESS",
  GET_MORE_MATCHES_FAILURE: "GET_MORE_MATCHES_FAILURE",

  GET_FAVORITES_REQUESTED: "GET_FAVORITES_REQUESTED",
  GET_FAVORITES_SUCCESS: "GET_FAVORITES_SUCCESS",
  GET_FAVORITES_FAILURE: "GET_FAVORITES_FAILURE",

  POST_FAVORITES_REQUESTED: "POST_FAVORITES_REQUESTED",
  POST_FAVORITES_SUCCESS: "POST_FAVORITES_SUCCESS",
  POST_FAVORITES_FAILURE: "POST_FAVORITES_FAILURE",

  DELETE_FAVORITES_REQUESTED: "DELETE_FAVORITES_REQUESTED",
  DELETE_FAVORITES_SUCCESS: "DELETE_FAVORITES_SUCCESS",
  DELETE_FAVORITES_FAILURE: "DELETE_FAVORITES_FAILURE",

  GET_TIMESHEET_LIST_REQUESTED: "GET_TIMESHEET_LIST_REQUESTED",
  GET_TIMESHEET_LIST_SUCCESS: "GET_TIMESHEET_LIST_SUCCESS",
  GET_TIMESHEET_LIST_FAILURE: "GET_TIMESHEET_LIST_FAILURE",

  GET_TIMESHEET_REQUESTED: "GET_TIMESHEET_REQUESTED",
  GET_TIMESHEET_SUCCESS: "GET_TIMESHEET_SUCCESS",
  GET_TIMESHEET_FAILURE: "GET_TIMESHEET_FAILURE",

  APPROVE_ALL_TIMESHEET_REQUESTED: "APPROVE_ALL_TIMESHEET_REQUESTED",
  APPROVE_ALL_TIMESHEET_SUCCESS: "APPROVE_ALL_TIMESHEET_SUCCESS",
  APPROVE_ALL_TIMESHEET_FAILURE: "APPROVE_ALL_TIMESHEET_FAILURE",

  EDIT_TIMESHEET_REQUESTED: "EDIT_TIMESHEET_REQUESTED",
  EDIT_TIMESHEET_SUCCESS: "EDIT_TIMESHEET_SUCCESS",
  EDIT_TIMESHEET_FAILURE: "EDIT_TIMESHEET_FAILURE",

  APPROVE_TIMESHEET_REQUESTED: "APPROVE_TIMESHEET_REQUESTED",
  APPROVE_TIMESHEET_SUCCESS: "APPROVE_TIMESHEET_SUCCESS",
  APPROVE_TIMESHEET_FAILURE: "APPROVE_TIMESHEET_FAILURE",

  APPROVE_TIME_OFF_REQUESTED: "APPROVE_TIME_OFF_REQUESTED",
  APPROVE_TIME_OFF_SUCCESS: "APPROVE_TIME_OFF_SUCCESS",
  APPROVE_TIME_OFF_FAILURE: "APPROVE_TIME_OFF_FAILURE",

  REJECT_TIMESHEET_REQUESTED: "REJECT_TIMESHEET_REQUESTED",
  REJECT_TIMESHEET_SUCCESS: "REJECT_TIMESHEET_SUCCESS",
  REJECT_TIMESHEET_FAILURE: "REJECT_TIMESHEET_FAILURE",

  REJECT_TIME_OFF_REQUESTED: "REJECT_TIME_OFF_REQUESTED",
  REJECT_TIME_OFF_SUCCESS: "REJECT_TIME_OFF_SUCCESS",
  REJECT_TIME_OFF_FAILURE: "REJECT_TIME_OFF_FAILURE",

  SEARCH_CANDIDATEMARKET_INIT: "SEARCH_CANDIDATEMARKET_INIT",
  SEARCH_CANDIDATEMARKET_SUCCESS: "SEARCH_CANDIDATEMARKET_SUCCESS",
  SEARCH_CANDIDATEMARKET_FAILURE: "SEARCH_CANDIDATEMARKET_FAILURE",
  SEARCH_CANDIDATEMARKET_VALUE: "SEARCH_CANDIDATEMARKET_VALUE",

  GET_ALL_TEAM_REQUESTED: "GET_ALL_TEAM_REQUESTED",
  GET_ALL_TEAM_SUCCESS: "GET_ALL_TEAM_SUCCESS",
  GET_ALL_TEAM_FAILURE: "GET_ALL_TEAM_FAILURE",

  TEAM_PAGE_FETCH_REQUESTED: "TEAM_PAGE_FETCH_REQUESTED",
  TEAM_PAGE_FETCH_SUCCESS: "TEAM_PAGE_FETCH_SUCCESS",
  TEAM_PAGE_FETCH_FAILURE: "TEAM_PAGE_FETCH_FAILURE",

  ADD_TEAM_REQUESTED: "ADD_TEAM_REQUESTED",
  ADD_TEAM_SUCCESS: "ADD_TEAM_SUCCESS",
  ADD_TEAM_FAILURE: "ADD_TEAM_FAILURE",

  UPDATE_TEAM_REQUESTED: "UPDATE_TEAM_REQUESTED",
  UPDATE_TEAM_SUCCESS: "UPDATE_TEAM_SUCCESS",
  UPDATE_TEAM_FAILURE: "UPDATE_TEAM_FAILURE",

  DELETE_TEAM_REQUESTED: "DELETE_TEAM_REQUESTED",
  DELETE_TEAM_SUCCESS: "DELETE_TEAM_SUCCESS",
  DELETE_TEAM_FAILURE: "DELETE_TEAM_FAILURE",
  DELETE_TEAM_RESET: "DELETE_TEAM_RESET",

  ADD_TEAM_RESET: "ADD_TEAM_RESET",

  GET_NOTIFICATION_REQUESTED: "GET_NOTIFICATION_REQUESTED",
  GET_NOTIFICATION_SUCCESS: "GET_NOTIFICATION_SUCCESS",
  GET_NOTIFICATION_FAILURE: "GET_NOTIFICATION_FAILURE",

  VIEW_INCREMENT_REQUESTED: "VIEW_INCREMENT_REQUESTED",
  VIEW_INCREMENT_SUCCESS: "VIEW_INCREMENT_SUCCESS",
  VIEW_INCREMENT_FAILURE: "VIEW_INCREMENT_FAILURE",

  GET_GRAPH_DETAILS_REQUESTED: "GET_GRAPH_DETAILS_REQUESTED",
  GET_GRAPH_DETAILS_SUCCESS: "GET_GRAPH_DETAILS_SUCCESS",
  GET_GRAPH_DETAILS_FAILURE: "GET_GRAPH_DETAILS_FAILURE",

  GET_MATCH_REQUESTED: "GET_MATCH_REQUESTED",
  GET_MATCH_SUCCESS: "GET_MATCH_SUCCESS",
  GET_MATCH_FAILURE: "GET_MATCH_FAILURE",

  GET_MATCH_SORT: "GET_MATCH_SORT",
  GET_MATCH_SORT_SUCCESS: "GET_MATCH_SORT_SUCCESS",
  GET_MATCH_SORT_FAILURE: "GET_MATCH_SORT_FAILURE",

  GET_ALL_PAYMENTS_REQUESTED: "GET_ALL_PAYMENTS_REQUESTED",
  GET_ALL_PAYMENTS_SUCCESS: "GET_ALL_PAYMENTS_SUCCESS",
  GET_ALL_PAYMENTS_FAILURE: "GET_ALL_PAYMENTS_FAILURE",

  REACTIVATE_TEAM_MEMBER_REQUESTED: "REACTIVATE_TEAM_MEMBER_REQUESTED",
  REACTIVATE_TEAM_MEMBER_REQUESTED_SUCCESS:
    "REACTIVATE_TEAM_MEMBER_REQUESTED_SUCCES",
  REACTIVATE_TEAM_MEMBER_REQUESTED_FAILURE:
    "REACTIVATE_TEAM_MEMBER_REQUESTED_FAILURE",

  GET_MESSAGES_INBOX_REQUESTED: "GET_MESSAGES_INBOX_REQUESTED",
  GET_MESSAGES_INBOX_SUCCESS: "GET_MESSAGES_INBOX_SUCCESS",
  GET_MESSAGES_INBOX_FAILURE: "GET_MESSAGES_INBOX_FAILURE",

  POST_RATING_REQUESTED: "POST_RATING_REQUESTED",
  POST_RATING_SUCCESS: "POST_RATING_SUCCESS",
  POST_RATING_FAILURE: "POST_RATING_FAILURE",

  PUT_RATING_REQUESTED: "PUT_RATING_REQUESTED",
  PUT_RATING_SUCCESS: "PUT_RATING_SUCCESS",
  PUT_RATING_FAILURE: "PUT_RATING_FAILURE",

  DELETE_RATING_REQUESTED: "DELETE_RATING_REQUESTED",
  DELETE_RATING_SUCCESS: "DELETE_RATING_SUCCESS",
  DELETE_RATING_FAILURE: "DELETE_RATING_FAILURE",

  GET_CANDIDATES_REQUESTED: "GET_CANDIDATES_REQUESTED",
  GET_CANDIDATES_SUCCESS: "GET_CANDIDATES_SUCCESS",
  GET_CANDIDATES_FAILURE: "GET_CANDIDATES_FAILURE",

  GET_CANDIDATES_COUNTS_REQUESTED: "GET_CANDIDATES_COUNTS_REQUESTED",
  GET_CANDIDATES_COUNTS_SUCCESS: "GET_CANDIDATES_COUNTS_SUCCESS",
  GET_CANDIDATES_COUNTS_FAILURE: "GET_CANDIDATES_COUNTS_FAILURE",

  GET_JOB_TITLES_REQUESTED: "GET_JOB_TITLES_REQUESTED",
  GET_JOB_TITLES_FAILURE: "GET_JOB_TITLES_FAILURE",
  GET_JOB_TITLES_SUCCESS: "GET_JOB_TITLES_SUCCESS",

  POST_OFFER_REQUESTED: "POST_OFFER_REQUESTED",
  POST_OFFER_FAILURE: "POST_OFFER_FAILURE",
  POST_OFFER_SUCCESS: "POST_OFFER_SUCCESS",

  EDIT_OFFER_REQUESTED: "EDIT_OFFER_REQUESTED",
  EDIT_OFFER_SUCCESS: "EDIT_OFFER_SUCCESS",
  EDIT_OFFER_FAILURE: "EDIT_OFFER_FAILURE",

  GET_RECENT_SEARCHES_INIT: "GET_RECENT_SEARCHES_INIT",
  GET_RECENT_SEARCHES_SUCCESS: "GET_RECENT_SEARCHES_SUCCESS",
  GET_RECENT_SEARCHES_FAILURE: "GET_RECENT_SEARCHES_FAILURE",

  CLEAR_RECENT_SEARCH_INIT: "CLEAR_RECENT_SEARCH_INIT",
  CLEAR_RECENT_SEARCH_SUCCESS: "CLEAR_RECENT_SEARCH_SUCCESS",
  CLEAR_RECENT_SEARCH_FAILURE: "CLEAR_RECENT_SEARCH_FAILURE",

  GET_TRENDING_JOBS_INIT: "GET_TRENDING_JOBS_INIT",
  GET_TRENDING_JOBS_SUCCESS: "GET_TRENDING_JOBS_SUCCESS",
  GET_TRENDING_JOBS_FAILURE: "GET_TRENDING_JOBS_FAILURE",

  UPDATE_IMPERSONATION_ID: "UPDATE_IMPERSONATION_ID",

  CLEAR_RATING_CHECK: "CLEAR_RATING_CHECK",
  GET_INBOX_JOB_DETAILS: "GET_INBOX_JOB_DETAILS",

  GET_ABS_ACCOUNTS: "GET_ABS_ACCOUNTS",
  GET_ABS_ACCOUNTS_SUCCESS: "GET_ABS_ACCOUNTS_SUCCESS",
  GET_ABS_ACCOUNTS_FAILURE: "GET_ABS_ACCOUNTS_FAILURE",

  POST_NOTES_REQUESTED: "POST_NOTES_REQUESTED",
  POST_NOTES_SUCCESS: "POST_NOTES_SUCCESS",
  POST_NOTES_FAILURE: "POST_NOTES_FAILURE",

  GET_NOTES_REQUESTED: "GET_NOTES_REQUESTED",
  GET_NOTES_SUCCESS: "GET_NOTES_SUCCESS",
  GET_NOTES_FAILURE: "GET_NOTES_FAILURE",

  GET_REMINDERS_REQUESTED: "GET_REMINDERS_REQUESTED",
  GET_REMINDERS_SUCCESS: "GET_REMINDERS_SUCCESS",
  GET_REMINDERS_FAILURE: "GET_REMINDERS_FAILURE",

  GET_RATING_REQUESTED: "GET_RATING_REQUESTED",
  GET_RATING_SUCCESS: "GET_RATING_SUCCESS",
  GET_RATING_FAILURE: "GET_RATING_FAILURE",

  UPDATES_NOTES_REQUESTED: "UPDATES_NOTES_REQUESTED",
  UPDATES_NOTES_SUCCESS: "UPDATES_NOTES_SUCCESS",
  UPDATES_NOTES_FAILURE: "UPDATES_NOTES_FAILURE",
  UPDATES_NOTES_RESET: "UPDATES_NOTES_RESET",
  DELETE_NOTE_REQUESTED: "DELETE_NOTE_REQUESTED",
  DELETE_NOTE_SUCCESS: "DELETE_NOTE_SUCCESS",
  DELETE_NOTE_FAILURE: "DELETE_NOTE_FAILURE",

  FETCH_DECLINED_REASONS_BIDS_INIT: "FETCH_DECLINED_REASONS_BIDS_INIT",
  FETCH_DECLINED_REASONS_BIDS_SUCCESS: "FETCH_DECLINED_REASONS_BIDS_SUCCESS",
  FETCH_DECLINED_REASONS_BIDS_FAILURE: "FETCH_DECLINED_REASONS_BIDS_FAILURE",

  SEND_EMAIL_VERIFICATION_INIT: "SEND_EMAIL_VERIFICATION_INIT",
  SEND_EMAIL_VERIFICATION_SUCCESS: "SEND_EMAIL_VERIFICATION_SUCCESS",
  SEND_EMAIL_VERIFICATION_FAILURE: "SEND_EMAIL_VERIFICATION_FAILURE",

  GET_JOB_COUNTS_REQUESTED: "GET_JOB_COUNTS_REQUESTED",
  GET_JOB_COUNTS_SUCCESS: "GET_JOB_COUNTS_SUCCESS",
  GET_JOB_COUNTS_FAILURE: "GET_JOB_COUNTS_FAILURE",

  GET_CANDIDATE_COUNTS_REQUESTED: "GET_CANDIDATE_COUNTS_REQUESTED",
  GET_CANDIDATE_COUNTS_SUCCESS: "GET_CANDIDATE_COUNTS_SUCCESS",
  GET_CANDIDATE_COUNTS_FAILURE: "GET_CANDIDATE_COUNTS_FAILURE",

  CLEAR_SEARCH_SUGGESTIONS_REQUESTED: "CLEAR_SEARCH_SUGGESTIONS_REQUESTED",

  GET_JOB_RESULT_LISTING: "GET_JOB_RESULT_LISTING",
  GET_JOB_RESULT_LISTING_SUCCESS: "GET_JOB_RESULT_LISTING_SUCESS",
  GET_JOB_RESULT_LISTING_FAILURE: "GET_JOB_RESULT_LISTING_FAILURE",

  GET_JOB_RESULT_LISTING_DRAFT: "GET_JOB_RESULT_LISTING_DRAFT",
  GET_JOB_RESULT_LISTING_SUCESS_DRAFT: "GET_JOB_RESULT_LISTING_SUCESS_DRAFT",
  GET_JOB_RESULT_LISTING_FAILURE_DRAFT: "GET_JOB_RESULT_LISTING_FAILURE_DRAFT",

  SEARCH_MY_GIGS_LOCATION_INIT: "SEARCH_MY_GIGS_LOCATION_INIT",
  SEARCH_MY_GIGS_DYNAMIC_LOCATION_INIT: "SEARCH_MY_GIGS_DYNAMIC_LOCATION_INIT",
  SEARCH_MY_GIGS_DYNAMIC_LOCATION_SUCCESS:
    "SEARCH_MY_GIGS_DYNAMIC_LOCATION_SUCCESS",
  SEARCH_MY_GIGS_DYNAMIC_LOCATION_FAILURE:
    "SEARCH_MY_GIGS_DYNAMIC_LOCATION_FAILURE",

  FETCH_MY_GIGS_SEARCH_SKILLS_INIT: "FETCH_MY_GIGS_SEARCH_SKILLS_INIT",
  FETCH_MY_GIGS_SEARCH_SKILLS_SUCCESS: "FETCH_MY_GIGS_SEARCH_SKILLS_SUCCESS",
  FETCH_MY_GIGS_SEARCH_SKILLS_FAILURE: "FETCH_MY_GIGS_SEARCH_SKILLS_FAILURE",
  GET_BID_PLACE_PROPS: "GET_BID_PLACE_PROPS",

  REMOVE_PRIVATE_MARKET_TALENT: "REMOVE_PRIVATE_MARKET_TALENT",
  REMOVE_PRIVATE_MARKET_TALENT_SUCCESS: "REMOVE_PRIVATE_MARKET_TALENT_SUCESS",
  REMOVE_PRIVATE_MARKET_TALENT_FAILURE: "REMOVE_PRIVATE_MARKET_TALENT_FAILURE",

  USER_LANDED: "USER_LANDED",
  USER_CLICK: "USER_CLICK",
  USER_CLICKED_SUCCESS: "USER_CLICKED_SUCCESS",

  HRM_DETAILS_INIT: "HRM_DETAILS_INIT",
  HRM_DETAILS_SUCCESS: "HRM_DETAILS_SUCCESS",
  HRM_DETAILS_FAILURE: "HRM_DETAILS_FAILURE",

  ABS_DETAILS_INIT: "ABS_DETAILS_INIT",
  ABS_DETAILS_SUCCESS: "ABS_DETAILS_SUCCESS",
  ABS_DETAILS_FAILURE: "ABS_DETAILS_FAILURE",

  FETCH_INVITED_CANDIDATES: "FETCH_INVITED_CANDIDATES",
  FETCH_INVITED_CANDIDATES_SUCCESS: "FETCH_INVITED_CANDIDATES_SUCCESS",
  FETCH_INVITED_CANDIDATES_FAILURE: "FETCH_INVITED_CANDIDATES_FAILURE",
  FETCH_INVITE_TRACKING_INVITES: "FETCH_INVITE_TRACKING_INVITES",
  FETCH_INVITE_TRACKING_INVITES_SUCCESS: "FETCH_INVITE_TRACKING_INVITES_SUCCESS",
  FETCH_INVITE_TRACKING_INVITES_FAILURE: "FETCH_INVITE_TRACKING_INVITES_FAILURE",

  FETCH_CANDIDATE_SKILLS_INIT: "FETCH_CANDIDATE_SKILLS_INIT",
  FETCH_CANDIDATE_SKILLS_SUCCESS: "FETCH_CANDIDATE_SKILLS_SUCCESS",
  FETCH_CANDIDATE_SKILLS_FAILURE: "FETCH_CANDIDATE_SKILLS_FAILURE",

  CANDIDATE_DETAILS_INIT: "CANDIDATE_DETAILS_INIT",
  CANDIDATE_DETAILS_SUCCESS: "CANDIDATE_DETAILS_SUCCESS",
  CANDIDATE_DETAILS_FAILURE: "CANDIDATE_DETAILS_FAILURE",
  MARK_MESSAGE_AS_READ: "MARK_MESSAGE_AS_READ",
  RESET_HEADER_STATE: "RESET_HEADER_STATE",
  TOGGLE_SEARCH_TRUE: "TOGGLE_SEARCH_TRUE",
  TOGGLE_SEARCH_FALSE: "TOGGLE_SEARCH_FALSE",
  OPEN_SEARCH_DROPDOWN: "OPEN_SEARCH_DROPDOWN",
  RESET_OPEN_SEARCH_DROPDOWN: "RESET_OPEN_SEARCH_DROPDOWN",

  CONFIG_TIME_SHEET: "CONFIG_TIME_SHEET",
  CONFIG_TIME_SHEET_INTI: "CONFIG_TIME_SHEET_INTI",
  CONFIG_TIME_SHEET_REQUESTED: "CONFIG_TIME_SHEET_REQUESTED",
  CONFIG_TIME_SHEET_SUCCESS: "CONFIG_TIME_SHEET_SUCCESS",
  CONFIG_TIME_SHEET_FAILURE: "CONFIG_TIME_SHEET_FAILURE",

  TIME_OFF_REQUESTED: "TIME_OFF_REQUESTED",
  TIME_OFF_SUCCESS: "TIME_OFF_SUCCESS",
  TIME_OFF_FAILURE: "TIME_OFF_FAILURE",

  GET_CONFIG_TIME_SHEET_INIT: "GET_CONFIG_TIME_SHEET_INIT",
  GET_CONFIG_TIME_SHEET_SUCCESS: "GET_CONFIG_TIME_SHEET_SUCCESS",
  GET_CONFIG_TIME_SHEET_FAILURE: "GET_CONFIG_TIME_SHEET_FAILURE",
 FETCH_VMS_REQUEST : "FETCH_VMS_REQUEST",
 FETCH_VMS_SUCCESS : "FETCH_VMS_SUCCESS",
 FETCH_VMS_FAILURE :"FETCH_VMS_FAILURE",
 FETCH_FACILITY_REQUEST: "FETCH_FACILITY_REQUEST",
FETCH_FACILITY_SUCCESS: "FETCH_FACILITY_SUCCESS",
FETCH_FACILITY_FAILURE: "FETCH_FACILITY_FAILURE",

  FETCH_USER_TAG_REQUEST : "FETCH_USER_TAG_REQUEST",
  FETCH_USER_TAG_SUCCESS : "FETCH_USER_TAG_SUCCESS",
  FETCH_USER_TAG_FAILURE : "FETCH_USER_TAG_FAILURE",

  // QueryPage — External Talent
  SEARCH_EXTERNAL_USERS_INIT: "SEARCH_EXTERNAL_USERS_INIT",
  SEARCH_EXTERNAL_USERS_SUCCESS: "SEARCH_EXTERNAL_USERS_SUCCESS",
  SEARCH_EXTERNAL_USERS_FAILURE: "SEARCH_EXTERNAL_USERS_FAILURE",
  SEARCH_EXTERNAL_USERS_CLEAR: "SEARCH_EXTERNAL_USERS_CLEAR",

  // QueryPage — Internal Talent (associated talents)
  GET_ASSOCIATED_TALENTS_INIT: "GET_ASSOCIATED_TALENTS_INIT",
  GET_ASSOCIATED_TALENTS_SUCCESS: "GET_ASSOCIATED_TALENTS_SUCCESS",
  GET_ASSOCIATED_TALENTS_FAILURE: "GET_ASSOCIATED_TALENTS_FAILURE",

  // QueryPage — Marketplace Talent (skill listing search)
  SEARCH_SKILLLISTING_QUERY_INIT: "SEARCH_SKILLLISTING_QUERY_INIT",
  SEARCH_SKILLLISTING_QUERY_SUCCESS: "SEARCH_SKILLLISTING_QUERY_SUCCESS",
  SEARCH_SKILLLISTING_QUERY_FAILURE: "SEARCH_SKILLLISTING_QUERY_FAILURE",

  // External Talent detail page
  GET_EXTERNAL_USER_DETAIL_INIT: "GET_EXTERNAL_USER_DETAIL_INIT",
  GET_EXTERNAL_USER_DETAIL_SUCCESS: "GET_EXTERNAL_USER_DETAIL_SUCCESS",
  GET_EXTERNAL_USER_DETAIL_FAILURE: "GET_EXTERNAL_USER_DETAIL_FAILURE",

  NL_SEARCH_EXTERNAL_INIT: "NL_SEARCH_EXTERNAL_INIT",
  NL_SEARCH_EXTERNAL_SUCCESS: "NL_SEARCH_EXTERNAL_SUCCESS",
  NL_SEARCH_EXTERNAL_FAILURE: "NL_SEARCH_EXTERNAL_FAILURE",
  NL_SEARCH_EXTERNAL_CLEAR: "NL_SEARCH_EXTERNAL_CLEAR",

  FETCH_EXTERNAL_CONTACT_INIT: "FETCH_EXTERNAL_CONTACT_INIT",
  FETCH_EXTERNAL_CONTACT_SUCCESS: "FETCH_EXTERNAL_CONTACT_SUCCESS",
  FETCH_EXTERNAL_CONTACT_FAILURE: "FETCH_EXTERNAL_CONTACT_FAILURE",

  FETCH_PLANS_REQUESTED: "FETCH_PLANS_REQUESTED",
  FETCH_PLANS_SUCCESS: "FETCH_PLANS_SUCCESS",
  FETCH_PLANS_FAILURE: "FETCH_PLANS_FAILURE",
  MARK_PLANS_DIRTY: "MARK_PLANS_DIRTY",
  MARK_QUERY_PARAM_MODAL_DIRTY: "MARK_QUERY_PARAM_MODAL_DIRTY",
  QUERY_PARAM_MODAL_CHECKED: "QUERY_PARAM_MODAL_CHECKED",

  FETCH_CREDIT_TRANSACTIONS_REQUESTED: "FETCH_CREDIT_TRANSACTIONS_REQUESTED",
  FETCH_CREDIT_TRANSACTIONS_SUCCESS: "FETCH_CREDIT_TRANSACTIONS_SUCCESS",
  FETCH_CREDIT_TRANSACTIONS_FAILURE: "FETCH_CREDIT_TRANSACTIONS_FAILURE",

  FETCH_CREDITS_BALANCE_REQUESTED: "FETCH_CREDITS_BALANCE_REQUESTED",
  FETCH_CREDITS_BALANCE_SUCCESS: "FETCH_CREDITS_BALANCE_SUCCESS",
  FETCH_CREDITS_BALANCE_FAILURE: "FETCH_CREDITS_BALANCE_FAILURE",

  WRITE_WITH_AI_INIT: "WRITE_WITH_AI_INIT",
  WRITE_WITH_AI_SUCCESS: "WRITE_WITH_AI_SUCCESS",
  WRITE_WITH_AI_FAILURE: "WRITE_WITH_AI_FAILURE",

  CREATE_FIRST_JOB_INIT: "CREATE_FIRST_JOB_INIT",
  CREATE_FIRST_JOB_SUCCESS: "CREATE_FIRST_JOB_SUCCESS",
  CREATE_FIRST_JOB_FAILURE: "CREATE_FIRST_JOB_FAILURE",

  SEARCH_DEPARTMENTS_INIT: "SEARCH_DEPARTMENTS_INIT",
  SEARCH_DEPARTMENTS_SUCCESS: "SEARCH_DEPARTMENTS_SUCCESS",
  SEARCH_DEPARTMENTS_FAILURE: "SEARCH_DEPARTMENTS_FAILURE",

  SEARCH_TALENTS_INIT: "SEARCH_TALENTS_INIT",
  SEARCH_TALENTS_SUCCESS: "SEARCH_TALENTS_SUCCESS",
  SEARCH_TALENTS_FAILURE: "SEARCH_TALENTS_FAILURE",

  CREATE_PROJECT_INIT: "CREATE_PROJECT_INIT",
  CREATE_PROJECT_SUCCESS: "CREATE_PROJECT_SUCCESS",
  CREATE_PROJECT_FAILURE: "CREATE_PROJECT_FAILURE",

  FETCH_PROJECTS_INIT: "FETCH_PROJECTS_INIT",
  FETCH_PROJECTS_SUCCESS: "FETCH_PROJECTS_SUCCESS",
  FETCH_PROJECTS_FAILURE: "FETCH_PROJECTS_FAILURE",

  FETCH_PROJECT_DETAIL_INIT: "FETCH_PROJECT_DETAIL_INIT",
  FETCH_PROJECT_DETAIL_SUCCESS: "FETCH_PROJECT_DETAIL_SUCCESS",
  FETCH_PROJECT_DETAIL_FAILURE: "FETCH_PROJECT_DETAIL_FAILURE",

  UPDATE_PROJECT_INIT: "UPDATE_PROJECT_INIT",
  UPDATE_PROJECT_SUCCESS: "UPDATE_PROJECT_SUCCESS",
  UPDATE_PROJECT_FAILURE: "UPDATE_PROJECT_FAILURE",

  UPDATE_PROJECT_STATUS_INIT: "UPDATE_PROJECT_STATUS_INIT",
  UPDATE_PROJECT_STATUS_SUCCESS: "UPDATE_PROJECT_STATUS_SUCCESS",
  UPDATE_PROJECT_STATUS_FAILURE: "UPDATE_PROJECT_STATUS_FAILURE",

  FETCH_PROJECT_HISTORY_INIT: "FETCH_PROJECT_HISTORY_INIT",
  FETCH_PROJECT_HISTORY_SUCCESS: "FETCH_PROJECT_HISTORY_SUCCESS",
  FETCH_PROJECT_HISTORY_FAILURE: "FETCH_PROJECT_HISTORY_FAILURE",

  ADD_PROJECT_MANAGERS_INIT: "ADD_PROJECT_MANAGERS_INIT",
  ADD_PROJECT_MANAGERS_SUCCESS: "ADD_PROJECT_MANAGERS_SUCCESS",
  ADD_PROJECT_MANAGERS_FAILURE: "ADD_PROJECT_MANAGERS_FAILURE",

  FETCH_ENGRO_TALENTS_INIT: "FETCH_ENGRO_TALENTS_INIT",
  FETCH_ENGRO_TALENTS_SUCCESS: "FETCH_ENGRO_TALENTS_SUCCESS",
  FETCH_ENGRO_TALENTS_FAILURE: "FETCH_ENGRO_TALENTS_FAILURE",
};
